import React from 'react'
import { SxProps } from '@mui/material'
import { Typography } from '../Typography'

interface SlicedLineProps {
  text: string
  max: number
  readMore?: boolean
  showMoreText?: string
  hideMoreText?: string
  triggerSx?: SxProps
}

function SlicedLine({
  text,
  max,
  readMore,
  showMoreText,
  hideMoreText,
  triggerSx = {
    color: '#DB2357'
  }
}: SlicedLineProps) {
  const [showMore, setShowMore] = React.useState(false)
  return (
    <>
      {`${showMore && text.length > max ? text : `${text.slice(0, max)}${text.length > max ? '...' : ''}`}`}
      {readMore && text.length > max && (
        <Typography
          onClick={() => setShowMore(!showMore)}
          sx={{
            ...triggerSx,
            marginLeft: '5px',
            cursor: 'pointer'
          }}
          component="span"
        >
          {showMore ? hideMoreText : showMoreText}
        </Typography>
      )}
    </>
  )
}

export { SlicedLine, type SlicedLineProps }
